import React from "react";
import AdListingSection from "../../../components/main-layout-components/ad-listing-section/AdListingSection";
import FilterBar from "../../../components/main-layout-components/filter-bar/FilterBar";
import PriceFilter from "../../../components/main-layout-components/advanced-filters/price-filter/PriceFilter";
import ThirdPartyAdSpace from "../../../components/common/third-party-ad-space/ThirdPartyAdSpace";
import useApiService from "../../../hooks/useApiService";
import { getThirdPartyAds } from "../../../services/admin-service/adminService";
import { BannerSpace } from "../../../types/admin-types/adminTypes";
import { ThirdPartyBannerSpace } from "../../../enums/ThirdPartyBannerSpace";

function AdListingPage() {
  const { data: thirdPartyAdList } = useApiService({
    serviceCall: () => getThirdPartyAds(null),
    dependencies: [],
  });

  const topBanner: BannerSpace | undefined = thirdPartyAdList?.find(
    (s: BannerSpace) => s.location === ThirdPartyBannerSpace.ADS_LISTING_TOP
  );
  const leftBanner: BannerSpace | undefined = thirdPartyAdList?.find(
    (s: BannerSpace) => s.location === ThirdPartyBannerSpace.ADS_LISTING_LEFT
  );
  const sidebarBanner: BannerSpace | undefined = thirdPartyAdList?.find(
    (s: BannerSpace) => s.location === ThirdPartyBannerSpace.ADS_LISTING_RIGHT
  );

  return (
    <div style={{ minHeight: "calc(100vh - 68px)", background: "#f8fafc", padding: "1.75rem 0 3rem" }}>
      <div className="maximum-width mx-auto px-3">

        {/* Top leaderboard banner */}
        {(topBanner?.ad_presigned_urls?.length ?? 0) > 0 && (
          <div style={{ marginBottom: "1.25rem", borderRadius: 14, overflow: "hidden" }}>
            <ThirdPartyAdSpace
              urls={topBanner!.ad_presigned_urls}
              aspectRatio={topBanner!.resolution}
            />
          </div>
        )}

        {/* Filter bar card */}
        <div style={{
          background: "#fff",
          borderRadius: 14,
          border: "1.5px solid #f0f4f8",
          boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
          padding: "0.875rem 1.5rem",
          marginBottom: "1.25rem",
        }}>
          <FilterBar />
        </div>

        {/* Mobile: advanced filters */}
        <div className="d-block d-md-none mb-3">
          <div style={{
            background: "#fff",
            borderRadius: 14,
            border: "1.5px solid #f0f4f8",
            boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
            padding: "1.25rem",
          }}>
            <PriceFilter />
          </div>
        </div>

        {/* Main content card */}
        <div style={{
          background: "#fff",
          borderRadius: 14,
          border: "1.5px solid #f0f4f8",
          boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
          overflow: "hidden",
        }}>
          <AdListingSection leftBanner={leftBanner} sidebarBanner={sidebarBanner} />
        </div>

      </div>
    </div>
  );
}

export default AdListingPage;
